export default __webpack_public_path__ + "static/media/ringtune.081fa884.svg";